export enum CountryState {
  QLD = 'QLD',
  VIC = 'VIC',
  ACT = 'ACT',
  SA = 'SA',
  NT = 'NT',
  WA = 'WA',
  NSW = 'NSW',
  TAS = 'TAS',
}

export enum Metro {
  Brisbane = 'Brisbane',
  Melbourne = 'Melbourne',
  Canberra = 'Canberra',
  Adelaide = 'Adelaide',
  Darwin = 'Darwin',
  Perth = 'Perth',
  Sydney = 'Sydney',
  Hobart = 'Hobart',
}

export const STATE_PER_METRO: Record<Metro, CountryState> = {
  [Metro.Brisbane]: CountryState.QLD,
  [Metro.Melbourne]: CountryState.VIC,
  [Metro.Canberra]: CountryState.ACT,
  [Metro.Adelaide]: CountryState.SA,
  [Metro.Darwin]: CountryState.NT,
  [Metro.Perth]: CountryState.WA,
  [Metro.Sydney]: CountryState.NSW,
  [Metro.Hobart]: CountryState.TAS,
};

export const AUSTRALIA = 'Australia';

export const STATE_FULL_NAMES: Record<CountryState, string | undefined> = {
  [CountryState.ACT]: 'Australian Capital Territory',
  [CountryState.NSW]: 'New South Wales',
  [CountryState.NT]: 'Northern Territory',
  [CountryState.QLD]: 'Queensland',
  [CountryState.SA]: 'South Australia',
  [CountryState.TAS]: 'Tasmania',
  [CountryState.VIC]: 'Victoria',
  [CountryState.WA]: 'Western Australia',
};

export enum GovernmentScheme {
  CHILD_DENTAL_BENEFITS_SCHEDULE = 'Child Dental Benefits Schedule',
  CHRONIC_MEDICAL_CONDITION_ASSISTANCE = 'Chronic Medical Condition Assistance',
  COUNTRY_PATIENTS_DENTAL_SUBSIDY_SCHEME = 'Country Patients Dental Subsidy Scheme',
  DEPARTMENT_OF_VETERANS_AFFAIRS_CARD_HOLDERS = 'Department of Veterans Affairs Card Holders',
  EMERGENCY_DENTAL_SCHEME_SA = 'Emergency Dental Scheme (SA)',
  GENERAL_DENTAL_SCHEME_SA = 'General Dental Scheme (SA)',
  HEALTH_CARE_HOME = 'Health Care Home',
  HEARING_SERVICES_PROGRAM = 'Hearing Services Program',
  NATIONAL_DISABILITY_INSURANCE_SCHEME = 'National Disability Insurance Scheme',
  PENSIONER_DENTURE_SCHEME_SA = 'Pensioner Denture Scheme (SA)',
  PRACTICE_INCENTIVES_PROGRAM = 'Practice Incentives Program',
  PREMIUM_SUPPORT_SCHEME = 'Premium Support Scheme',
  TRANSPORT_ACCIDENT_COMMISSION_VICTORIA_CLAIM = 'Transport Accident Commission Victoria Claim',
  VICTORIAN_DENTURE_SCHEME = 'Victorian Denture Scheme',
  VICTORIAN_EMERGENCY_DENTAL_SCHEME = 'Victorian Emergency Dental Scheme',
  VICTORIAN_GENERAL_DENTAL_SCHEME = 'Victorian General Dental Scheme',
  WORKSAFE_VICTORIA = 'Worksafe Victoria',
}

export enum PaymentMethod {
  AFTERPAY = 'Afterpay',
  AMEX = 'Amex',
  DENTICARE = 'DentiCare',
  EFTPOS = 'Eftpos',
  GEM_VISA = 'Gem Visa',
  HICAPS = 'HICAPS',
  MASTERCARD = 'Mastercard',
  MEDIPAY = 'Medipay',
  MYSMILEPLAN = 'MySmilePlan',
  MYSUPERCARE = 'MySupercare',
  TOTAL_LIFESTYLE_CREDIT = 'Total Lifestyle Credit',
  VISA = 'Visa',
  ZIP_MONEY = 'Zip Money',
}

export enum InsuranceProvider {
  AHM = 'AHM',
  AustralianUnity = 'Australian Unity',
  BUPA = 'BUPA',
  CBHS = 'CBHS',
  GMHBA = 'GMHBA',
  HBF = 'HBF',
  HCF = 'HCF',
  HealthPartners = 'Health Partners',
  HIF = 'HIF',
  HunterHealthInsurance = 'Hunter Health Insurance',
  Medibank = 'Medibank',
  NIB = 'NIB',
  NursesMidwivesHealth = 'Nurses & Midwives Health',
  TeachersHealthFund = 'Teachers Health Fund',
  TUH = 'TUH',
  UniHealth = 'Uni Health',
  UnionHealth = 'Union Health',
  Westfund = 'Westfund',
}
